//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
// import {
//   postJwtLogin,

// } from "../../../helpers/fakebackend_helper";
import { getAuthMe } from "../../../slices/auth/user/thunk";


import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";
import { useNavigate } from 'react-router-dom';
import { Constant } from "utils/enums";
import { postLogin, authMe, getBusinessBySellerId } from "helpers/backend_helper";
import { toast } from "react-toastify";
import { handleLogout } from "helpers/api_helper";
import { Environment } from "environment";


export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    let response;
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      let fireBaseBackend: any = getFirebaseBackend();
      response = fireBaseBackend.loginUser(user.email, user.password);
    }
    else if (Environment.apiUrl) {
      response = postLogin({
        userName: user.userName,
        password: user.password,
      });
    }

    var data = await response;

    if (data) {
      if(data.message) {
        toast.error(data.message);
        return;
      }
      toast.success("User Login successfully");
      localStorage.setItem(
        Constant.access_token,
        JSON.stringify(data.access_token)
      );
      localStorage.setItem(
        Constant.refresh_token,
        JSON.stringify(data.refresh_token)
      );
      let userD: any = await authMe();
      if (userD) {
        let userMain = JSON.stringify(userD)
        localStorage.setItem(
          Constant.user,
          userMain
        );
        dispatch(loginSuccess(JSON.parse(userMain)));

        const { isAddressAdded, isIdBankDetails, isProductAdded, isStoreCreated } = userD.storeStatus;
        if (isAddressAdded && isIdBankDetails && isProductAdded && isStoreCreated) {
          history('/manage-products'); 
        } else {
          if(!isStoreCreated){
          history('/set-seller-store');

          }
          else{

            history('/on-boarding');
          }
        
        }



      }
    }
    else {
      // toast.error("Invalid User credentials");
    }

  } catch (error: any) {
    dispatch(apiError(error));
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    let fireBaseBackend: any = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }
    handleLogout();
  } catch (error: any) {
    dispatch(apiError(error));
  }
};

export const socialLogin =
  (type: any, history: any) => async (dispatch: any) => {
    try {
      let response;

      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const fireBaseBackend: any = getFirebaseBackend();
        response = fireBaseBackend.socialLoginUser(type);
      }
      //  else {
      //   response = postSocialLogin(data);
      // }

      const socialdata = await response;

      if (socialdata) {
        // sessionStorage.setItem("authUser", JSON.stringify(response));
        dispatch(loginSuccess(response));
        // Dispatch `getAuthMe` and handle its completion
        const authResponse: any = await dispatch(getAuthMe()).unwrap(); // Assuming `getAuthMe` returns a promise and has `.unwrap()` from Redux Toolkit
        const userMain = JSON.stringify(authResponse);
        localStorage.setItem(Constant.user, userMain);
        // Extract `sub` from `authResponse` and call `getBusinessBySellerId`
        const sellerId = authResponse?.sub;
        if (sellerId) {
          dispatch(getBusinessBySellerId(sellerId));
        }

        history("/dashboard");
      }
    } catch (error: any) {
      dispatch(apiError(error));
    }
  };

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error: any) {
    dispatch(apiError(error));
  }
};
